const SWISS_SOCIAL_SECURITY_NUMBER_DIGIT_COUNT = 13

export const formatSocialSecurityNumber = (socialSecurityNumber: string | null | undefined): string => {
  if (!socialSecurityNumber) {
    return ""
  }

  const digits = socialSecurityNumber.replace(/\D/g, "")
  if (digits.length !== SWISS_SOCIAL_SECURITY_NUMBER_DIGIT_COUNT) {
    return socialSecurityNumber
  }

  return `${digits.slice(0, 3)}.${digits.slice(3, 7)}.${digits.slice(7, 11)}.${digits.slice(11)}`
}
